<template>
  <div class="number-input">
    <label v-if="title" class="label">{{ title }}</label>
    <input-number v-model="internalValue" :min="min" :max="max" title="dfsdf" class="input-number" :disabled='disabled'/>
  </div>
</template>
<script>
import { InputNumber } from 'element-ui';

export default {
  name: 'NumberInput',
  components: {
    InputNumber,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Number,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    title: String,
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.number-input {
  display: flex;
  flex-direction: column;

  width: 85px;
}

label {
  display: block;
  color: var(--text-tertiary);
  font-family: $font-family-regular;
  font-size: $font-size-xs;
  letter-spacing: 0.8px;
  line-height: $font-size-xs;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.input-number {
  height: 28px;
  width: 100%;

  ::v-deep .el-input {
    height: 28px;
    display: flex;
  }

  ::v-deep input {
    border-radius: $radius-sm;
    height: 28px;
    padding: 0 22px;
    font-family: $font-family-regular;
    font-size: $font-size-base;
  }

  ::v-deep span {
    position: absolute;
    height: $font-size-md;
    width: $font-size-md;
    display: flex;
    background: rgba(77, 159, 235, 0.1);
    border: none;
    align-items: center;
    justify-content: center;

    &.el-input-number__decrease {
      top: $space-1-5;
      left: $space-1-5;
    }

    &.el-input-number__increase {
      top: $space-1-5;
      right: $space-1-5;
    }

    & i::before {
      color: var(--status-info);
      font-weight: bold;
      font-size: $font-size-sm;
    }

    &.is-disabled i::before {
      color: var(--text-muted);
    }
  }
}
</style>
